import * as _ from "lodash";
import {DashboardWidget} from "../models/DashboardWidget";
import {CachingCollection} from "./_BaseCollection";

interface DashboardWidgetOptions {
    dashboardId: number;
    tabId?: number;
}

export class DashboardWidgetCollection extends CachingCollection<DashboardWidget> {

    urlRoot = '/api/v1/dashboards/';

    dashboardId: number;
    tabId?: number;

    constructor(initialModels?: Object[] | any[], options?: DashboardWidgetOptions) {
        super(initialModels, _.extend({model: DashboardWidget}, options));
        if (options) {
            this.dashboardId = options.dashboardId;
            this.tabId = options.tabId;
        }
    }


    url = () => {
        var url = this.urlRoot + this.dashboardId + '/widgets';
        if (this.tabId) {
            url += '?tabId=' + this.tabId;
        }
        return url;
    };

    comparator = (model) => {
        return model.get('order');
    };
}



// WEBPACK FOOTER //
// ./srv/public/js/collections/DashboardWidgets.ts